export const deepClone = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    const clone = (Array.isArray(obj) ? [] : {});
    for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            clone[key] = deepClone(obj[key]);
        }
    }
    return clone;
};
